// import lib
import isEmpty from './isEmpty';

export const percentageCalculation = (price, percentage) => {
    price = parseFloat(price);
    percentage = parseFloat(percentage)

    if (!isEmpty(price)) {
        return price - (price * (percentage / 100))
    }
    return 0
}

export const balanceConvention = (balance, conventionAmt) => {
    balance = parseFloat(balance);
    conventionAmt = parseFloat(conventionAmt)
    if (!isEmpty(conventionAmt)) {
        return balance * conventionAmt
    }
    return 0
}

export const findPerc = (value, totalVal) => {
    value = Number(value)
    totalVal = Number(totalVal)
    return (value / totalVal) * 100;
}

export const precentConvetPrice = (price, percentage) => {
    price = parseFloat(price);
    percentage = parseFloat(percentage)

    if (!isEmpty(price)) {
        return price * (percentage / 100)
    }
    return 0
}

export const interestByDays = (price, rate, days) => {
    price = parseFloat(price);
    rate = parseFloat(rate)
    days = parseFloat(days);

    if (!isEmpty(price) && !isEmpty(rate) && !isEmpty(days)) {
        return ((price * (rate / 100)) / days)
    }
    return 0
}

export const diffValue = (start, end, type = 'percentage') => {
    try {
        let diff = 0;
        if (!isEmpty(start) && !isEmpty(end)) {
            diff = (end / start)
        }
        if (type == 'percentage') {
            return diff * 100
        }
        return diff
    } catch (err) {
        return 0
    }
}

export const decreaseValue = (start, end) => {
    try {
        if (!isEmpty(start) && !isEmpty(end)) {
            return (start - end) / (start * 100)
        }

        return 0
    } catch (err) {
        return 0
    }
}

export const completionValue = (start, end) => {
    try {
        if (!isEmpty(start) && !isEmpty(end)) {
            return (end / start) * 100
        }

        return 0
    } catch (err) {
        return 1
    }
}

/** 
 * Calculate Without Service Fee
*/
export const withoutServiceFee = ({
    price,
    serviceFee
}) => {
    price = parseFloat(price)
    serviceFee = parseFloat(serviceFee)
    return price - (price * (serviceFee / 100))
}

export const daysToMonths = (days) => {
    const daysInMonth = 30.44; // Average number of days in a month
    const months = days / daysInMonth;
    return months;
}

export const remainingDaysUntilFutureDate = (futureDate) => {
    // Convert the future date to a Date object
    const futureDateTime = new Date(futureDate);

    // Get the current date
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const timeDifference = futureDateTime.getTime() - currentDate.getTime();

    // Calculate the remaining days
    const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    return remainingDays;
}

export const isLeapYear = (year) => {
    // Leap years are divisible by 4
    // Years divisible by 100 are not leap years, unless they are divisible by 400
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}